let submitInProgress = false;

window.initContactForm = function () {
    const contactForm = document.getElementById('contact_form')
    if (!contactForm) {
        return;
    }
console.log('initializing contact form')
    contactForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (submitInProgress) {
            return;
        }
        var submitButton = document.querySelector('#contact_form input[type=submit]');
        submitButton.value = 'Laster...';
        submitButton.setAttribute('disabled', 'disabled');
        document.querySelectorAll('#contact_form ._showOnError, #contact_form ._showOnSuccess').forEach(function (el) {
            el.style.display = 'none';
        });
        submitInProgress = true;
        var data = new FormData(this);
        fetch('/contact', {
            method: 'POST',
            body: data
        }).then(response => response.json()).then(function (res) {
            if (res.status != 'ok') {
                if (res.message) {
                    document.querySelector('#contact_form ._showOnError p').textContent = res.message;
                } else {
                    document.querySelector('#contact_form ._showOnError p').textContent = $t('Det skjedde noe galt. Prøv igjen senere.');
                }
                    document.querySelector('#contact_form ._showOnError').style.display = 'block';
                return;
            }
            document.querySelector('#contact_form ._showOnSuccess').style.display = 'block';
            document.querySelectorAll('#contact_form input[type=text], #contact_form textarea').forEach(function (el) {
                el.value = '';
            });
        }).catch(e => {
            document.querySelector('#contact_form ._showOnError p').textContent = $t('Det skjedde noe galt. Prøv igjen senere.');
            document.querySelector('#contact_form ._showOnError').style.display = 'block';
        }).finally(() => {
            submitButton.value = 'Send';
            submitButton.removeAttribute('disabled');
            submitInProgress = false;
        });
    });
}